import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { SizeProvider } from "context/SizeProvider";
import { BrowserRouter } from "react-router-dom";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <SizeProvider>
        <App />
      </SizeProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root")
);
